import MovimientoCrud from './MovimientoCrud'
export {MovimientoCrud}
export default MovimientoCrud
